import { render, staticRenderFns } from "./ManageNovel.vue?vue&type=template&id=38c089e5&scoped=true&"
import script from "./ManageNovel.vue?vue&type=script&lang=js&"
export * from "./ManageNovel.vue?vue&type=script&lang=js&"
import style0 from "./ManageNovel.vue?vue&type=style&index=0&id=38c089e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c089e5",
  null
  
)

export default component.exports